import { render, staticRenderFns } from "./SubCategoryMobileRow.vue?vue&type=template&id=1251233c&scoped=true"
import script from "./SubCategoryMobileRow.vue?vue&type=script&lang=js"
export * from "./SubCategoryMobileRow.vue?vue&type=script&lang=js"
import style0 from "./SubCategoryMobileRow.vue?vue&type=style&index=0&id=1251233c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1251233c",
  null
  
)

export default component.exports